import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import withWebsiteContent from '../../../common/withWebsiteContent';
import { sectionScrollMarginSx } from '../../../common/hooks/useScrollSpyHash';

/**
 * Compact hero for the About page. Earthy gradient, headline and subline
 * focused on active holidays and nature.
 */
export const AboutHeroPure = ({ id, headline, subline, images = [] }) => {
  if (!headline && !subline) return null;

  return (
    <Box
      id={id}
      component="section"
      sx={{
        ...sectionScrollMarginSx,
        position: 'relative',
        py: { xs: 8, md: 12 },
        color: 'white',
        textAlign: 'center',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #1a3c34 0%, #2d5a4a 35%, #3d6b5a 70%, #4a7c6a 100%)',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(ellipse at 30% 20%, rgba(255,255,255,0.08) 0%, transparent 50%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Container sx={{ position: 'relative', zIndex: 1 }}>
        {headline && (
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.75rem' },
              lineHeight: 1.2,
            }}
          >
            {headline}
          </Typography>
        )}
        {subline && (
          <Typography
            variant="h6"
            sx={{
              maxWidth: 640,
              mx: 'auto',
              opacity: 0.95,
              fontSize: { xs: '1rem', md: '1.15rem' },
              fontWeight: 400,
            }}
          >
            {subline}
          </Typography>
        )}
      </Container>
    </Box>
  );
};

const AboutHero = withWebsiteContent(AboutHeroPure);
AboutHero.displayName = 'AboutHero';

export default AboutHero;
